import RemoveAdvanceGroupDialog from './RemoveAdvanceGroupDialog';

export default RemoveAdvanceGroupDialog;
